import FooterComponent from './Footer.vue'
export default FooterComponent
